<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>

<script setup lang="ts">
// 默认SEO 内容
useHead({
  title: useT('seo.seo_title'),
  meta: [
    {
      name: 'description',
      content: useT('seo.seo_desc')
    },
    {
      name: 'keywords',
      content: useT('seo.seo_keywords')
    }
  ]
});
</script>

<style scoped lang="scss"></style>
